import React, { useContext, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Input } from '../../../../components/ui';
import { SearchIcon } from '../../../../components/ui/icons';
import { ContextAlert } from '../../../../store/contexts/contextAlert';
import { actionAlert } from '../../../../store/actions/actionAlert';
import styles from './HeaderSearch.module.css';

export default function HeaderSearch({ links }) {
  const history = useHistory();
  const { dispatchAlert } = useContext(ContextAlert);
  const { t } = useTranslation('header');
  const [searchText, setSearchText] = useState('');
  const inputRef = useRef(null);

  const pathname = history.location.pathname;
  const isHome = pathname === '/';
  const isCatalog = pathname.startsWith('/catalogo');

  const searchCatalogo = () => {
    if (searchText.length > 0) {
      history.push(`/catalogo/${searchText}`); // eslint-disable-line no-restricted-syntax
    } else {
      dispatchAlert({
        type: actionAlert.ADD,
        payload: {
          message: 'WARNING',
          description: t('SEARCH_PLACEHOLDER'),
          type: 'warning'
        }
      });
    }
  };

  if (isCatalog) return null;

  if (!isHome) {
    return (
      <Link
        to='/catalogo'
        className={styles.triggerLink}
        aria-label={t('SEARCH')}>
        <SearchIcon size={18} style={{ color: 'var(--ui-blue-link)' }} />
      </Link>
    );
  }

  return (
    <>
      <Link
        to={links.catalogoCliente}
        className={`${styles.iconLink} ${styles.mobileOnly}`}
        aria-label={t('SEARCH')}>
        <SearchIcon size={22} style={{ color: 'var(--ui-text-muted)' }} />
      </Link>
      <form
        className={`${styles.searchForm} ${styles.desktopOnly}`}
        onClick={() => inputRef.current?.focus()}
        onSubmit={e => {
          e.preventDefault();
          searchCatalogo();
        }}>
        <Input
          ref={inputRef}
          className={styles.searchInput}
          icon={
            <button type='submit' className={styles.iconBtn}>
              <SearchIcon size={19} style={{ color: '#485585' }} />
            </button>
          }
          size='large'
          placeholder={t('TYPE_WHAT_YOU_NEED')}
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          aria-label={t('TYPE_WHAT_YOU_NEED')}
        />
      </form>
    </>
  );
}
